module.exports = __webpack_public_path__ + "img/019.29aa9301.png";